import { render, staticRenderFns } from "./GestioneDipendenti.vue?vue&type=template&id=379112f6&scoped=true"
import script from "./GestioneDipendenti.vue?vue&type=script&lang=js"
export * from "./GestioneDipendenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379112f6",
  null
  
)

export default component.exports